export namespace BinConstraintTranslations {
  export const common = {
    binConstraint: 'binConstraint',
  } as const;

  export const error = {
    binConstraintsUnableToLoadError: 'binConstraintsUnableToLoadError',
  } as const;

  export const filter = {
    binConstraintFilter: 'binConstraintFilter',
  } as const;

  export const compontents = {
    binConstraintSubtitle: 'binConstraintSubtitle',

    binConstraintCreate: 'binConstraintCreate',
    binConstraintUpdate: 'binConstraintUpdate',

    binConstraintDelete: 'binConstraintDelete',
    binConstraintDeleteTitle: 'binConstraintDeleteTitle',
  } as const;
}
